// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "css/" + chunkId + "." + {"597":"518a23fb","945":"70278592"}[chunkId] + ".css";
};